import React, { Component } from 'react';
import { Link } from 'react-router';
import { history } from '../../../../store';

/* eslint-disable */
export default class AccountSettingsDevices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      toggle: '',
    };
  }

  handleBack() {
    history.push('/account/settings')
  }

  render() {
    return (
      <div className="panel-view">
        <div className="panel-view-header small">
          <div className="view-header-left">
            <Link onClick={this.handleBack}>
              <i className="icon icon-arrow-left" />
            </Link>
          </div>
          <div className="view-header-center">
            <h2>Devices</h2>
          </div>
        </div>
        <div className="information information-banner">
          <h3>Du möchtest alle deine Geräte verbinden?</h3>
          <p>Mit der Pro Mitgliedschaft hebst du das 2 Geräte Limit auf und bist mit all deinen Geräten auf dem neusten Stand.</p>
          <div className="information-button">
            <Link className="button">Upgrade</Link>
            <i className="icon icon-info" />
          </div>
        </div>
        <div className="panel-view-content">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Device</th>
                <th>Location</th>
                <th>Activity</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chrome Browser</td>
                <td>Duren, Germany</td>
                <td>22.09.2017, 15:12</td>
                <td><button className="button alert">Logout</button></td>
              </tr>
              <tr>
                <td>iPad Pro</td>
                <td>Duren, Germany</td>
                <td>22.09.2017, 19:20</td>
                <td><button className="button alert">Logout</button></td>
              </tr>
            </tbody>
            <tfoot>
              <tr style={{ textAlign: 'center' }}>
                <td colSpan="4">2 of 2 devices</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/settings/devices/index.jsx